/**
 * SEO 工具函数
 * 用于动态设置页面的 title 和 meta 标签
 */

const DEFAULT_OG_IMAGE = 'https://manga.ko3672.com/web_SEO.png'

/**
 * 设置页面 SEO 元数据
 * @param {string} title - 页面标题
 * @param {string} description - 页面描述
 * @param {object} options - 可选配置
 * @param {string} options.image - OG 图片 URL
 * @param {string} options.url - 页面 URL
 * @param {string} options.type - OG 类型，默认 'website'
 */
export function setSeoMeta(title, description, options = {}) {
  const {
    image = DEFAULT_OG_IMAGE,
    url = window.location.href,
    type = 'website'
  } = options

  // 设置页面标题
  document.title = title

  // 设置 html lang 属性
  const lang = document.documentElement.lang || 'zh-CN'

  // 定义要设置的 meta 标签
  const metaTags = [
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:image', content: image },
    { property: 'og:type', content: type },
    { property: 'og:url', content: url },
    { property: 'og:locale', content: lang },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: image },
  ]

  // 更新或创建 meta 标签
  metaTags.forEach(({ name, property, content }) => {
    const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`
    let el = document.querySelector(selector)
    if (el) {
      el.setAttribute('content', content)
    } else {
      el = document.createElement('meta')
      if (name) el.setAttribute('name', name)
      if (property) el.setAttribute('property', property)
      el.setAttribute('content', content)
      document.head.appendChild(el)
    }
  })
}
